import { FETCH_ALL, SORT } from "../constants/action_types.js";

const album_handler = (albums = [], action) =>
{
  switch (action.type)
  {
    case FETCH_ALL:
      let hold = [...action.payload];
      let sorted_albums = hold.sort((a, b) => a.album.toLowerCase() < b.album.toLowerCase() ? -1 : 1);
      let sorted_and_indexed_albums = sorted_albums.map((album, i) =>
      {
        return { ...album, index: i }
      })
      return sorted_and_indexed_albums;
    case SORT:
      return albums;
    default:
      return albums;
  }
}

export default album_handler;
